import { AgentInterface } from '../Agent/Agent.Model'
import {
  EscalationAnalyticsGroup,
  EscalationsAnalyticsAgent,
  HourOfDay
} from '../Analytics/EscalationAnalytics.Model'
import { InheritanceStatus } from '../Quests/Quest.Interfaces'
import { UserInterface } from '../User/User.Model'

export enum EscalationPlatform {
  SWIVL = 'swivl', // Pending Opt In
  TEAMS = 'teams',
  SLACK = 'slack'
}

export enum EscalationStatus {
  PENDING = 'pending', // Pending Opt In
  ASSIGNED = 'assigned',
  ACTIVE = 'active',
  HANDLED = 'handled',
  // MISSED   = "missed", // This means agents were tried but none found
  // IGNORED  = "ignored",
  // UNAVAILABLE = "unavailable",
  // OUTSIDE_HOURS = "outside of hours",
  // OPT_OUT = "opt out",
  TIMED_OUT = 'timed out', // This means the no agent accepted
  OUTSIDE_HOURS = 'outside of hours',
  NO_AGENT_AVAILABLE = 'no agent available',
  USER_IS_BLOCKED = 'user is blocked'
}
/**
 * @tsoaModel
 */
export interface EscalationInterface {
  id: string
  createdAt: Date
  botId: string
  groupId: string
  groupSlug: string
  groupName: string
  platform: EscalationPlatform
  status: EscalationStatus
  assignedAgent?: AgentInterface
  assignedAgentId?: string
  assignedTimestamp?: number
  history?: EscalationHistory[]
  user: UserInterface
  userName?: string
  // agentsAttempted?:number
  agentsAttemptedIds?: string[]

  resolved: boolean
  // Add what quest / qNode it was recorded in.
  takeoverStarted?: number
  takeoverEnded?: number
  slackMessages?: EscalationSlackMessages

  agentInitiated?: boolean

  initialAgentStatus?: AgentsStatus

  summary?: string
}

export interface AgentsStatus {
  groupId: string
  groupSlug: string
  groupName: string
  numberOfAgents: number
  noAgentsAvailable: boolean
  ignoreAvailability: boolean
  available: { id: string; name: string }[]
  unvailable: { id: string; name: string }[]
  agentAvailable: { [key: string]: boolean }
  error?: any
}

/**
 * @tsoaModel
 */
export interface EscalationErrorInterface {
  error: EscalationErrorType
  message: string
  escalation?: EscalationInterface
}

export enum EscalationErrorType {
  TIMED_OUT = 'timed out',
  REASSIGNED = 'reassigned',
  UNKNOWN = 'unknown'
}

export enum EscalationHistoryEvent {
  CREATED = 'CREATED',
  AGENT_INITIATED = 'agent initiated',
  AVAILABLE_AGENTS_LOOKED_UP = 'available agents looked up', // DEPRECATED
  ASSIGNED_TO_AGENT = 'assigned to agent',
  AGENT_ACCEPTED = 'agent accepted',
  AGENT_REJECT = 'agent reject',
  AGENT_MISSED = 'agent missed',
  CONVERSATION_ENDED = 'conversation ended',

  TIMED_OUT = 'timed out',
  NO_AGENT_AVAILABLE = 'no agent available',
  OUTSIDE_HOURS = 'outside hours',
  USER_IS_BLOCKED = 'user is blocked'
}
export interface EscalationHistory {
  event: EscalationHistoryEvent
  agent?: AgentInterface
  date: Date
  message?: string
  data?: any
}

export interface EscalationsGroupInterface {
  id: string
  slug?: string
  inheritance?: InheritanceStatus
  botId: string

  initialMessage: string // Sent right away.

  outsideHoursQuestId?: string
  noAvailableAgentsQuestId?: string
  wontWaitQuestId?: string

  wontWaitQuestSlug?: string
  outsideHoursQuestSlug?: string
  noAvailableAgentsQuestSlug?: string

  multipleEscalationsResponse: string

  agentMessage?: string

  platform: EscalationPlatform
  name: string
  hours: HoursOfOperationInterface
  queue: boolean
  numberOfAgentsToTry: number
  secondsToWaitForAgent: number

  message: string

  teamsTeamId?: string
  teamsChannelId?: string
  agentIds?: string[]

  slackChannelId?: string
  groupChannelMessage?: string // Optional message sent in to group channel informing agents of issues.

  ignoreAvailability?: boolean
}

export interface EscalationPlatformSettings {
  swivl?: any
  slack?: any
  teams?: any
}

export interface HoursOfOperationInterface {
  timezone: string
  sun: HoursInterface
  mon: HoursInterface
  tue: HoursInterface
  wed: HoursInterface
  thu: HoursInterface
  fri: HoursInterface
  sat: HoursInterface
}

export interface HoursInterface {
  // 24 hour based.
  open: boolean
  start: string
  end: string // HH:mm format
}

export type EscalationSlackMessages = {
  [key in string]?: EscalationSlackMessage // Note that "key in".
}
export interface EscalationSlackMessage {
  type: EscalationSlackMessageType
  ts: string
  channelId: string
  agentId?: string
}
export enum EscalationSlackMessageType {
  CHANNEL = 'channel',
  AGENT = 'agent'
}
